<template>
  <!-- 线下付款申请单列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">

        <el-button plain
                   class="glo_btnItems glo_bgcMainColor"
                   @click="AddBtns"

        >新建</el-button
        >
        <el-button plain
                   class="glo_btnItems glo_bgcMainColor"
                   @click="EditBtns"

        >修改</el-button
        >
        <el-button plain
                   class="glo_btnItems glo_bgcMainColor"
                   @click="DelBtns"

        >删除</el-button
        >
        <el-button plain
                   class="glo_btnItems glo_bgcMainColor"
                   @click="PassBtns"

        >审批通过</el-button
        >
        <el-button plain
                   class="glo_btnItems glo_bgcMainColor"
                   @click="NotPassBtns"

        >审批拒绝</el-button
        >
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field === 'aaaaaaaaaa' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel">
                {{ scope.row.aaaaaaaaaa }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>

      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!--        自定义表头           -->
    <!-- <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
      ></sorttable> -->

    <!-- 导出插件 -->
    <!-- <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent> -->




  </div>
</template>
  <script>
import tableList from "@/pages/DynamicList/tableList.js";
  import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtnsDT.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/DialogDT.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import utils from "@/assets/js/tool";
//   import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import { Api } from "@/assets/js/api";
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import exportTb from "@/components/exportComponent/exportTb.vue"; //导出
import exportComponent from "@/components/exportComponent/index.vue"; //
export default {
  mixins: [tableList,tableListNew],
  inject: ["reload"],
  components: {
    paging,
    queryBtns,
    queryCondition,
    myDialog,
    exportTb,
    exportComponent
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "提货指令列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd===等待下载完成,bdd===不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "DynamicListBillOfflinePayList", //  页面标识
      reportFiledsNumber: "admin_bill_offline_pay_list", // 动态 条件、表头

      currentItemArr: [],
      dataList: [],
    };
  },
  mounted() {
    this.getData();
  },
  watch: {},
  created() {
  },
  methods: {
    // 表格选择事件
    handleSelectionChange(e) {
      this.currentItemArr = e || [];
    },

    // 不能输入负数
    minNum(val) {
      return val < 0 ? 0 : val;
    },

    //新增
    AddBtns(){
      this.$router.push({
        path: "/pages/v4/finance/billOfflinePayAdd",
        query: {
          pageType: "create",
        }
      });
    },
    //修改
    EditBtns(){

      if (this.currentItemArr.length !== 1) {
        this.$message.warning("请选择一条数据");
        return false;
      }

      this.$router.push({
        path: "/pages/v4/finance/billOfflinePayEdit",
        query: {
          pageType: "modify",
          id: this.currentItemArr[0].id
        },
      });
    },
    //删除
    DelBtns(){

      if (this.currentItemArr.length === 0) {
        this.$message.warning("请至少选择一条数据");
        return false;
      }
      const idList = this.currentItemArr.map((item) => {
        return item.id;
      });
      let params = {
        ids: idList,
      };
      ElMessageBox.confirm("是否所选单据进行删除？", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await Api.deleteBillOfflinePay(params).then((res) => {
              if (res.status === 200) {
                const data = res.data;
                if (utils.jyCheckObjectType(data) === "Object") {
                  ElMessage({
                    message: data.message,
                    type: data.status,
                  });
                  let that = this;
                  setTimeout(() => {
                    that.queryBtn_ok();
                  }, 500);
                }
              }
            });

          })
          .catch(() => {});
    },

    //审核通过
    PassBtns(){

      if (this.currentItemArr.length !== 1) {
        this.$message.warning("请选择一条数据");
        return false;
      }

      this.$router.push({
        path: "/pages/v4/finance/billOfflinePayEdit",
        query: {
          pageType: "checkPass",
          id: this.currentItemArr[0].id
        },
      });
    },
    //审核拒绝
    NotPassBtns(){

      if (this.currentItemArr.length !== 1) {
        this.$message.warning("请选择一条数据");
        return false;
      }

      this.$router.push({
        path: "/pages/v4/finance/billOfflinePayEdit",
        query: {
          pageType: "checkNotPass",
          id: this.currentItemArr[0].id
        },
      });
    },
  }

};
</script>
  <style scoped lang="scss">
::v-deep .el-date-editor.el-input {
  width: auto !important;
}


</style>
  